// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__2DA_-","footer":"ModalError_footer__11_KU"};